module.exports = __webpack_public_path__ + "img/05.snowy-cloudy-light.861415ec.svg";